<template>

			<div class="content">
		        <div class="container-fluid">
		        	<div class="row">
			            <div class="col-md-12">
			              <div class="card">
			                <div class="card-header card-header-info">
			                  <h4 class="card-title ">Tambah Pelanggan</h4>
							</div>
			                <div class="card-body">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <div class="form-group">
                                                <label class="bmd-label-floating">Nama</label>
                                                <input type="text" class="form-control" placeholder="Nama..." v-model="nama">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <div class="form-group">
                                                <label class="bmd-label-floating">ID PPOE</label>
                                                <input type="text" class="form-control" placeholder="PPOE..." v-model="ppoe">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <div class="form-group">
                                                <label class="bmd-label-floating">Mikrotik</label>
                                                <select class="form-control" id="exampleFormControlSelect1" placeholder="Pilih Resto..."  v-model="mikrotikPilih">
                                                    <option value="" selected disabled>Pilih Mikrotik</option>
                                                    <option v-for="(u, index) in mikrotik" :value="u.id" >{{u.nama}}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <div class="form-group">
                                                <label class="bmd-label-floating">Nomer WA</label>
                                                <input type="text" class="form-control" placeholder="Nama Area..." v-model="wa">
                                            </div>
                                        </div>
                                    </div>
                                </div>
								<div class="row">
									<div class="col-md-12">
                                        <div class="form-group">
											<div class="form-group">
                                                <label class="bmd-label-floating">Tanggal Tagihan</label>
												<vuejs-datepicker :format="customFormatter" placeholder="Sampai Tanggal..." style="width:100%" v-model="tanggal"></vuejs-datepicker>
											</div>
										</div>
									</div>
								</div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <div class="form-group">
                                                <label class="bmd-label-floating">Area</label>
                                                <select class="form-control" id="exampleFormControlSelect1" placeholder="Pilih Resto..."  v-model="areaPilih">
                                                    <option value="" selected disabled>Pilih Area</option>
                                                    <option v-for="(u, index) in area" :value="u.id" >{{u.nama}}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <div class="form-group">
                                                <label class="bmd-label-floating">Tarif</label>
                                                <select class="form-control" id="exampleFormControlSelect1" placeholder="Pilih Tarif..."  v-model="tarifPilih">
                                                    <option value="" selected disabled>Pilih Paket</option>
                                                    <option v-for="(u, index) in tarif" :value="u.id" >{{u.nama}}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>

								<div class="form-group">
									<label class="bmd-label-floating">Biaya Tambahan 1</label>
									<div class="row col-md-12 mb-3">
										<input type="text" class="form-control col-md-6" placeholder="Rincian Baiaya 1...." v-model="rincian1">
										<input type="number" class="form-control col-md-6" placeholder="Biaya Tambahan 1...." v-model="biaya1">
									</div>
									<label class="bmd-label-floating">Biaya Tambahan 2</label>
									<div class="row col-md-12">
										<input type="text" class="form-control col-md-6" placeholder="Rincian Baiaya 2...." v-model="rincian2">
										<input type="number" class="form-control col-md-6" placeholder="Biaya Tambahan 2" v-model="biaya2">
									</div>
								</div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <div class="form-group">
                                                <label class="bmd-label-floating">Diskon</label>
                                                <input type="number" class="form-control" placeholder="Diskon..." v-model="diskon">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <div class="form-group">
                                                <label class="bmd-label-floating">Alamat (opsional)</label>
                                                <input type="text" class="form-control" placeholder="Alamat..." v-model="alamat">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <div class="form-group">
                                                <label class="bmd-label-floating">Modem (opsional)</label>
                                                <input type="text" class="form-control" placeholder="Mis : TotoN200, TendaN300, tplink wr840" v-model="modem">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row" v-show="false">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <div class="form-group">
                                                <label class="bmd-label-floating">Password (opsional : jika ini diisi bisa digunakan pada aplikasi pelanggan.  <a href="https://play.google.com/store/apps/details?id=com.rtrw.myuser" target="_blank">Link Playstore</a> )</label>
                                                <input type="password" class="form-control" placeholder="Password..." v-model="password">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row" v-show="false">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <div class="form-group">
                                                <label class="bmd-label-floating">Konfirmasi Password</label>
                                                <input type="password" class="form-control" placeholder="Konfirmasi Password..." v-model="cpassword">
                                            </div>
                                        </div>
                                    </div>
                                </div>
			                    <div class="row">
			                      <div class="col-md-12">
									<div class="alert alert-warning" role="alert" v-show="alert">
										{{alertText}}
									</div>
								  </div>
								</div>

			                    <div class="row">
			                      <div class="col-md-12">
			                        <div class="form-group">
                                        <button class="btn btn-primary" @click="Simpan">Simpan</button>
			                        </div>
			                      </div>
			                    </div>
			                </div>
			              </div>
			            </div>
		        	</div>
		    	</div>
		    </div>
</template>

<script>

import Vue from 'vue'
import vuejsDatepicker from 'vuejs-datepicker'
import moment from 'moment'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { url } from '@/var/var.js'
import inter from '@/globalFunc/Interface' 
import { RedisSession } from '@/globalFunc/redis';

var numeral = require("numeral");

Vue.use(moment)

export default {
	components: { 
		vuejsDatepicker,
		moment,
	}, 
  	data() {
		return {
			title: "Detail Servis",
			nama: '',
			ppoe: '',
			wa: '',
			area: [],
			mikrotik: [],
			tarif: [],
			tanggal: '',
			areaPilih: '',
			tarifPilih: '',
			rincian1: '',
			rincian2: '',
			biaya1: '',
			biaya2: '',
			diskon: '',
			password: '',
			cpassword: '',
			mikrotikPilih: '',
			alert: false,
			alertText: '',
			modem: '',
			alamat: ''
		}
	},
	methods: {
		customFormatter (date) {
			return moment(date).format('DD');
		},
		getArea() {
			// for filter
			var data = new FormData();
			data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
			data.append('type', "all");
			data.append('bulan', "0");
			
			var apiUrl = inter.ListArea();
			this.PostData(data,apiUrl).then(x => {
				if (x.status) {
				this.area = x.data;
				} else {
				//alert(x.pesan);
				}
			})
		},
		getMikrotik() {
			// for filter
            var data = {
                token: 'TangTung '+sessionStorage.getItem('myToken')
            }
			
			var apiUrl = inter.MiktorikList();
			this.PostData(data,apiUrl).then(x => {
				if (x.status) {
					this.mikrotik = x.data;
				} else {
				//alert(x.pesan);
				}
			})
		},
		getTarif() {
			this.isCari = false;
            var data = {
                token: 'TangTung '+sessionStorage.getItem('myToken')
            }
			
			var apiUrl = inter.ListPaket();
			this.PostData(data,apiUrl).then(x => {
				if (x.status) {
				this.tarif = x.data;
				} else {
					//alert(x.pesan);
				}
			})
		},
        Simpan() {
			if (this.tarifPilih == "") {
				alert("Pilih Paket Terlebih dahulu");
				return false;
			}

			if (this.areaPilih == "") {
				alert("Pilih Area Terlebih dahulu");
				return false;
			}

			if (this.tanggal == "") {
				alert("Pilih Tanggal Terlebih dahulu");
				return false;
			}

			if (this.nama == "") {
				alert("Isikan Nama Terlebih dahulu");
				return false;
			}

			if (this.ppoe == "") {
				alert("Isikan PPOE Terlebih dahulu");
				return false;
			}

			if (this.wa == "") {
				alert("Isikan WA Terlebih dahulu");
				return false;
			}

			if (this.password != "") {
				if(this.password != this.cpassword) {
					alert("Password tidak sama");
					return false;
				}
			}
			
			/*
			var data = new FormData();
            data.append('token', );
            data.append('nama', this.nama);
            data.append('ppoe', this.ppoe);
            data.append('wa', this.wa);
			data.append('paket', this.tarifPilih);
			data.append('area', this.areaPilih);
			data.append('tanggal', moment(this.tanggal).format('DD'));
			*/
			var data = {
				token: 'TangTung '+sessionStorage.getItem('myToken'),
				nama: this.nama,
				ppoe: this.ppoe,
				wa: this.wa,
				paket: this.tarifPilih,
				area: this.areaPilih,
				rincian1: this.rincian1,
				rincian2: this.rincian2,
				diskon: this.diskon,
				biaya1: this.biaya1,
				biaya2: this.biaya2,
				tanggal: moment(this.tanggal).format('DD'),
				password: this.password,
				mikrotik: this.mikrotikPilih,
				alamat: this.alamat,
				modem: this.modem
			}
			
      		var apiUrl = inter.PelangganTambah();
            
			this.PostData(data,apiUrl).then(x => {
				// this.loger(x);
				if (x.status == "true") {
					

					RedisSession.clearUser();

                    location.href="#/pelanggan"
				} else {
					this.alert = true;
					this.alertText = x.pesan;
				}
			})
        }
	},
	mounted() {
		this.getArea();
		this.getTarif();
		this.getMikrotik();
	}
}
</script>

<style scoped>
.edit-input {
	font-size: 20pt !important;
}
.file-upload {
    opacity: 1 !important;
    position: relative !important;
    z-index: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/pelanggan/tambah.vue